import { render, staticRenderFns } from "./PostingCard.vue?vue&type=template&id=47246b9c"
import script from "./PostingCard.vue?vue&type=script&lang=ts"
export * from "./PostingCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47246b9c')) {
      api.createRecord('47246b9c', component.options)
    } else {
      api.reload('47246b9c', component.options)
    }
    module.hot.accept("./PostingCard.vue?vue&type=template&id=47246b9c", function () {
      api.rerender('47246b9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jobboard/PostingCard.vue"
export default component.exports